
import { defineComponent } from 'vue';
import UserItemFollow from '../user-item-follow/index.vue'

export default defineComponent({
  components: {
    UserItemFollow
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    isLoginStatus: {
      type: Boolean,
      default: false
    },
  },
  setup(props, ctx) {

    return {
    };
  },
});

